import React, { useState } from 'react'
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { convertirLetraMayus } from '../../../../helpers/convertirLetraMayus';
import { OpenLineResponse } from './OpenLineResponse';

export const SelectResponse = (props) => {

    const { action, options } = props;
    const [value, setValue] = useState(null);
    const classes = useStyles();

    const select = (e) => {
        setValue(e);
        if(e?.toLowerCase() !== 'otro')
            action(e?.toLowerCase().trim());
    }

    return (
        <Grid container justifyContent='center' alignItems='center'>
            <Grid item xs={ 10 } sm={ 7 } md={ 7 } lg={ 6 } xl={ 7 }>
                {
                    value?.toLowerCase() === 'otro' ? (
                        <OpenLineResponse 
                            action={ action } 
                            breakPoints={ [12, 12, 12, 12] }
                        />
                    ) : (
                        <select className={ classes.select } onChange={ e => select(e.target.value) }>
                            <option defaultValue=''>Selecciona una opción</option>
                            { options.map(o => <option key={o} value={ o }>{ convertirLetraMayus(o) }</option> ) }
                        </select>
                    )
                }
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles({
    select: {
        width: '100%', 
        borderRadius: 4, 
        padding: 10,

        '-webkit-appearance': 'none'
    }
});